<template>
    <div class="search-mobile">
        <div class="flex-center mt-6">
            <v-text-field 
                single-line
                clear-icon="mdi-close-circle"
                clearable
                type="text"
                placeholder="Введите текст"
                class="roboto-normal-18 clr-black-38"
                v-model="searchGlobal"
                @input="inputSearch"
                @click:clear="showedWindow = false"
            ></v-text-field>
            <img class="mb-4 ml-3" src="@/assets/images/components/search.svg">
        </div>
        <div v-if="searchGlobal && searchGlobal.length > 2 && showedWindow">
            <div class="tasks" v-if="foundedTasks.length">
                <div class="flex-center-between">
                    <div class="roboto-bold-18 clr-black-38">Подразделы</div>
                    <div class="flex-center">
                        <div class="round roboto-normal-12 clr-black-38">{{foundedTasks.length}}</div>
                        <img v-if="foundedTasks.length > 1 && !tasksShowed"  @click="tasksShowed = !tasksShowed" class="ml-2 arrow-up" height="18px" width="18px" src="@/assets/images/components/arrow-down.svg">
                        <img v-if="foundedTasks.length > 1 && tasksShowed"  @click="tasksShowed = !tasksShowed" class="ml-2" height="18px" width="18px" src="@/assets/images/components/arrow-down.svg">
                    </div>
                </div>
                <div class="mt-5">
                    <v-col class="center" v-for="(task, i) in showedTasks" :key="i">
                        <div @click="toTask(task)" class="task text-center roboto-normal-18 clr-black-38 pt-3 pointer">{{task.name}}</div>
                    </v-col>
                </div>
                <div 
                    class="center roboto-normal-16 clr-blue mt-1"
                    v-show="foundedTasks.length > 1 ? tasksShowed == false : tasksShowed == true" 
                    @click="tasksShowed = !tasksShowed"
                >Показать все
                </div>
                <div class="center">
                    <img @click="tasksShowed = !tasksShowed" v-show="foundedTasks.length > 1 ? tasksShowed == false : tasksShowed == true"  height="18px" width="18px" src="@/assets/images/components/arrow-down-blue.svg">
                </div>
            </div>
            <div class="subs mt-4" v-if="foundedSubs.length">
                <div class="flex-center-between">
                    <div class="roboto-bold-18 clr-black-38">Заметки</div>
                    <div class="flex-center">
                        <div class="round roboto-normal-12 clr-black-38">{{foundedSubs.length}}</div>
                        <img v-if="foundedSubs.length > 1 && !subsShowed"  @click="subsShowed = !subsShowed" class="ml-2 arrow-up" height="18px" width="18px" src="@/assets/images/components/arrow-down.svg">
                        <img v-if="foundedSubs.length > 1 && subsShowed"  @click="subsShowed = !subsShowed" class="ml-2" height="18px" width="18px" src="@/assets/images/components/arrow-down.svg">
                    </div>
                </div>
                <div class="mt-5">
                    <v-col v-for="(sub, i) in showedSubs" :key="i">
                        <ItemCard :sub="sub"/>
                    </v-col>
                </div>
                <div 
                    class="center roboto-normal-16 clr-blue mt-1"
                    v-show="foundedSubs.length > 1 ? subsShowed == false : subsShowed == true" 
                    @click="subsShowed = !subsShowed"
                >Показать все
                </div>
                <div class="center">
                    <img @click="subsShowed = !subsShowed" v-show="foundedSubs.length > 1 ? subsShowed == false : subsShowed == true"  height="18px" width="18px" src="@/assets/images/components/arrow-down-blue.svg">
                </div>
            </div>
            <div class="notices mt-4" v-if="foundedNotices.length">
                <div class="flex-center-between">
                    <div class="roboto-bold-18 clr-black-38">Лента</div>
                    <div class="flex-center">
                        <div class="round roboto-normal-12 clr-black-38">{{foundedNotices.length}}</div>
                        <img v-if="foundedNotices.length > 1 && !noticesShowed"  @click="noticesShowed = !noticesShowed" class="ml-2 arrow-up" height="18px" width="18px" src="@/assets/images/components/arrow-down.svg">
                        <img v-if="foundedNotices.length > 1 && noticesShowed"  @click="noticesShowed = !noticesShowed" class="ml-2" height="18px" width="18px" src="@/assets/images/components/arrow-down.svg">
                    </div>
                </div>
                <div class="my-5">
                    <v-col v-for="(notice, i) in showedNotices" :key="i">
                        <ItemCard @activated="closeWindowFromNotice" :notice="notice"/>
                    </v-col>
                </div>
                <div 
                    class="center roboto-normal-16 clr-blue mt-1"
                    v-show="foundedNotices.length > 1 ? noticesShowed == false : noticesShowed == true" 
                    @click="noticesShowed = !noticesShowed"
                >Показать все
                </div>
                <div class="center mb-5">
                    <img @click="noticesShowed = !noticesShowed" v-show="foundedNotices.length > 1 ? noticesShowed == false : noticesShowed == true"  height="18px" width="18px" src="@/assets/images/components/arrow-down-blue.svg">
                </div>
            </div>
            <v-list v-show="!(foundedNotices.length || foundedTasks.length || foundedSubs.length)" v-html="'По Вашему запросу ничего не найдено'"></v-list>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import SubMain from './../main/SubMain'
import Notice from './../feeds/Notice'
    import ItemCard from '@/components/main/ItemCard.vue'
export default {
    name: 'SearchMobile',
    components: {  
        ItemCard,
            SubMain,
        Notice
    },
    data() {
        return {
            searchGlobal: '',
            showedWindow: true,
            tasksShowed: false,
            subsShowed: false,
            noticesShowed: false,
        }
    },
    computed: {
        ...mapGetters(['feeds','themes']),
        allTasks() {
            return this.themes.map(theme => {
                return theme.tasks
            }).flat() 
        }, 
        foundedTasks() {
            return this.searchGlobal.length > 2 ? 
            this.allTasks.filter(task => task.name.toLowerCase().includes(this.searchGlobal.toLocaleLowerCase())) : []
        },
        showedTasks() {
            const showedAllTasks = !this.tasksShowed ? this.foundedTasks.slice(0,1) : this.foundedTasks
            return this.foundedTasks.length > 1 ? showedAllTasks : this.foundedTasks
        },
        allNotices() {
            return this.feeds.map(feed => {
                return feed.notices
            }).flat() 
        },
        foundedNotices() {
            return this.searchGlobal.length > 2 ? 
            this.allNotices.filter(notice => notice.body.toLowerCase().includes(this.searchGlobal.toLocaleLowerCase())) : []
        },
        showedNotices() {
            const showedAllNotices = !this.noticesShowed ? this.foundedNotices.slice(0,1) : this.foundedNotices 
            return this.foundedNotices.length > 1 ? showedAllNotices : this.foundedNotices
        },
        allSubs() {
            return this.themes.map(theme => {
                return theme.tasks.map(task => {
                    return task.subs
                }).flat()
            }).flat()
        },
        foundedSubs() {
            return this.searchGlobal.length > 2 ? 
            this.allSubs.filter(sub => sub.name.toLowerCase().includes(this.searchGlobal.toLocaleLowerCase())) : []
        },
        showedSubs() {
            const showedAllSubs = !this.subsShowed ? this.foundedSubs.slice(0,1) : this.foundedSubs
            return this.foundedSubs.length > 1 ? showedAllSubs : this.foundedSubs
        },
    },
    methods: {
        ...mapMutations(["SET_CURRENT_FEED",'SET_CURRENT']),
        ...mapActions(["setRelavantNotices"]),
        toTask(task) {
            const theme = this.themes.find(theme => {
                return theme.tasks.find(item => item._id == task._id)
            })
            this.SET_CURRENT(theme)
            this.setRelavantNotices(task)
            this.taskBody = task.body
            this.$router.push(`/theme/${theme.route_name}/${task.route_name}`)  
            this.showedWindow = false
            this.searchGlobal = ''
            this.$root.$emit('selectElementMenu')
            this.$emit('toTask')
            this.$root.$emit('openMobileTheme')
        },
        toSub(sub) {
            const theme = this.themes.find(theme => {
                return theme.tasks.find(task => {
                    return task.subs.find(item => item._id == sub._id)
                })
            })
            const task = theme.tasks.find(task => {
                return task.subs.find(item => item._id == sub._id)
            })
            this.SET_CURRENT(theme)
            this.setRelavantNotices(task)
            this.taskBody = task.body
            this.$router.push(`/theme/${theme.route_name}/${task.route_name}`) 
            this.showedWindow = false
            this.searchGlobal = ''
            let oldScroll = window.scrollY
            const toHash = setInterval(() => {
                const elementSub = document.getElementById(`sub-id-${sub._id}`)
                if (elementSub) { 
                    this.$vuetify.goTo(`#sub-id-${sub._id}`)
                }
                if (oldScroll != window.scrollY || oldScroll == 0) {
                    clearInterval(toHash)
                } 
                oldScroll = window.scrollY
            },30)
            this.$root.$emit('selectElementMenu')
            this.$emit('toTask')
            this.$root.$emit('openMobileTheme')
            this.$root.$emit('toCurrentSub', sub)
        },
        inputSearch(){
            this.showedWindow = true
        },
        closeWindowFromNotice() {
            this.showedWindow = false
            this.searchGlobal = ''
        }
    }
}
</script>

<style lang="scss" scoped>
.search-mobile {
    margin: 0 7%;
    .v-text-field {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 22px;
        letter-spacing: -0.408px;
        color: #383838;
        padding: 14px 0;
    }
    .round {
        background: #F2F2F2;
        height:26px;
        width:26px;
        line-height: 26px;
        border-radius: 50%;
        text-align: center;
    }
    .arrow-up {
        transform: rotate(180deg)
    }
    .center {
        display: flex;
        justify-content: center;
    }
    .task {
        width:100%;
        height: 47px;
        background: #EEEEEE;
        border-radius: 20px;
    }
}
</style>